import { useFormik } from "formik";
import Select from "../../../components/select";
import { useServerList } from "../layout/resuableEffect";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import { FormatDate } from "../../../hooks/constants";




const LoadBalancerInstances = () => {


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProject = useSelector((state) => state.user.selectedProject);
  const projectId = selectedProject?.id;


  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-instances", label: "All instances" },
    { value: "name", label: "Name" },
    { value: "status", label: "Status", },
  ];

  const userServer = useServerList();

  const userServerList = userServer
  ?.filter((server) => {
    return server.addresses && Object.values(server.addresses).some(addressList => addressList.length > 0);})
  .map((server) => {
    // rest of your existing mapping code
    const externalAddress = server.addresses?.External?.[0]?.addr;
    const allAddresses = Object.values(server.addresses)
      .flat()
      .map((address) => address.addr)
      .join(", ");

    return {
      name: server.name.replace(/_/g, " "),
      address: externalAddress || allAddresses || "",
      status: server.status === "ACTIVE" ? "Active" : "Inactive",
      id : server?.id,
      flavor: server?.flavor,
      image: server?.image,
      keyPair: server?.key_name || null,
      securityGroups: server?.security_groups,
      date: server?.created
    };
  });


    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 5;

    const filteredData = userServerList?.filter((row) =>
        row?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        row?.status?.toLowerCase().includes(searchText.toLowerCase()),
    );

    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = filteredData.slice(
        indexOfFirstEntry,
        indexOfLastEntry,
    );

    const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
        




  

  return (
    <div className="w-full mt-10">

        <h3 className="text-gray-700 text-lg font-semibold mb-4">
            Available Instances
        </h3>

        <div>
            {userServerList?.length > 0 ?
            <div>
                <div className="w-full flex items-center">
                    <div className="w-full  grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                        <div className="md:col-span-3">
                            <Select label="Filter instances" name="instances" options={options} />
                        </div>
                        <div className="md:col-span-4">
                        <input
                            type="search"
                            name=""
                            value={searchText}
                            onChange={handleSearchChange}
                            placeholder="Search for instance..."
                            className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                        />
                        </div>
                    </div>


                </div>

                <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
                <table className="w-full text-sm text-left overflow-hidden">
                    <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                    <tr>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                            #
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                            Name
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            IP Address
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                    {currentEntries.map((row, index) => (
                        <tr
                          key={index}
                          className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                        >
                        <td className="text-start py-4 px-6">{index + 1}.</td>
                        <td
                          className="text-start py-4 px-6 text-primaryBlue"
                        >
                          {row.name}
                        </td>
                        <td className="text-start py-4 px-6">{row.address}</td>
    
                    </tr>
                    ))}
                    </tbody>
                </table>
                </div>
                <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
                <p className="text-gray-400 text-sm">
                    Showing{" "}
                    <span className="font-medium text-black dark:text-white">
                        {indexOfFirstEntry + 1}
                    </span>{" "}
                        to{" "}
                    <span className="font-medium text-black dark:text-white">
                        {Math.min(indexOfLastEntry, userServerList?.length)}
                    </span>{" "}
                        of{" "}
                    <span className="font-medium text-black dark:text-white">
                        {userServerList?.length}
                    </span>{" "}
                    results
                </p>
                <div className=" flex gap-3">
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
                </div>
            </div>
    
            :
    
            <>
                <div className="md:px-52 text-center grid text-gray-500 mt-32">
                    <div>No instances available</div>
                </div>
            
            </> 
            
            }
            
        </div>
      




    </div>
  );
};

export default LoadBalancerInstances;
